import _extends from '/data/wwwroot/dongliyuanlin.com/web/node_modules/babel-runtime/helpers/extends';
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import CommonFooter from '~/components/CommonFooter';
export default {
  name: "ProjectDetail",
  components: {
    CommonFooter: CommonFooter
  },
  data: function data() {
    return {
      position: '0px',
      i: 0

    };
  },

  methods: {
    start: function start(e) {
      if (e.wheelDelta < -200) {
        $('#fullpage').css({ 'transform': 'translateY(-224px)' });
        document.removeEventListener('mousewheel', this.start, false);
        this.flag = true;
      }
    },
    callback: function callback() {}
  },
  computed: _extends({}, mapState(['winHeight', 'flag']), {
    up: function up() {
      return {
        height: this.winHeight - 60 + 'px'
      };
    }
  }),
  watch: {},
  created: function created() {},
  mounted: function mounted() {},
  destroyed: function destroyed() {}
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/data/wwwroot/dongliyuanlin.com/web/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/CommonContents.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/data/wwwroot/dongliyuanlin.com/web/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/CommonContents.vue
// module chunks = 1